import { useEffect } from "react";
import { Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import LenisProvider from "@/components/LenisProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import ASpaceArt from "@/pages/ASpaceArt";
import Libri from "@/pages/Libri";
import Contatti from "@/pages/Contatti";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-paper text-ink px-6 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-bordeaux">Errore</p>
          <h1 className="font-serif italic text-4xl mt-4">Qualcosa non ha funzionato.</h1>
          <button
            onClick={() => window.location.reload()}
            className="mt-8 border border-ink px-8 py-3 text-xs uppercase tracking-[0.2em] hover:bg-ink hover:text-paper transition-colors"
          >
            Ricarica la pagina
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LenisProvider />
        <ScrollToTop />
        <div className="min-h-screen bg-paper text-ink font-sans">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-sono" element={<ChiSono />} />
              <Route path="/a-space-art" element={<ASpaceArt />} />
              <Route path="/i-miei-libri" element={<Libri />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy" element={<Legal kind="privacy" />} />
              <Route path="/cookie-policy" element={<Legal kind="cookie" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <div className="grain-overlay" aria-hidden="true" />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                backgroundColor: "#1A1918",
                color: "#FBF9F5",
                border: "1px solid rgba(26,25,24,0.2)",
                borderRadius: "0",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
